import { actionSchema, stringify } from '@0xtorch/core'
import type { Chain, Converter, LowerHex } from '@0xtorch/evm'

export type EvmConverterPrimitive = (args: {
  nativeToken: Chain['nativeToken']
  relatedAddresses: LowerHex[]
  source: string
  transaction: string
}) => Promise<string | undefined>

export const createConverterByWorker =
  (evmConverter: EvmConverterPrimitive): Converter =>
  async ({ relatedAddresses, transaction, ...args }) => {
    console.log('createConverterByWorker', {
      relatedAddresses,
      transaction,
      ...args,
    })
    const result = await evmConverter({
      ...args,
      relatedAddresses: [...relatedAddresses],
      transaction: stringify(transaction),
    })
    if (result === undefined) {
      return undefined
    }
    return actionSchema.array().parse(JSON.parse(result))
  }
